export default __webpack_public_path__ + "b6e2ad83e7a4d67a0bebe4ea6d1b9745.png";